import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout, ProtectedRoute } from "@/components/Layout";

import Home from "@/pages/Home";
import Standorte from "@/pages/Standorte";
import StandortDetail from "@/pages/StandortDetail";
import Speisekarte from "@/pages/Speisekarte";
import Angebote from "@/pages/Angebote";
import HeliumVorteile from "@/pages/HeliumVorteile";
import Veranstaltungen from "@/pages/Veranstaltungen";
import Catering from "@/pages/Catering";
import Karriere from "@/pages/Karriere";
import KarriereDetail from "@/pages/KarriereDetail";
import DatenschutzBewerber from "@/pages/DatenschutzBewerber";
import UeberUns from "@/pages/UeberUns";
import Kontakt from "@/pages/Kontakt";
import Feedback from "@/pages/Feedback";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MeinKonto from "@/pages/MeinKonto";
import EmployeeScanner from "@/pages/EmployeeScanner";
import AdminDashboard from "@/pages/AdminDashboard";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/standorte" element={<Standorte />} />
              <Route path="/standorte/:slug" element={<StandortDetail />} />
              <Route path="/wochenmenue" element={<Navigate to="/speisekarte" replace />} />
              <Route path="/speisekarte" element={<Speisekarte />} />
              <Route path="/angebote" element={<Angebote />} />
              <Route path="/helium-vorteile" element={<HeliumVorteile />} />
              <Route path="/veranstaltungen" element={<Veranstaltungen />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/karriere" element={<Karriere />} />
              <Route path="/karriere/:slug" element={<KarriereDetail />} />
              <Route path="/datenschutz-bewerber" element={<DatenschutzBewerber />} />
              <Route path="/ueber-uns" element={<UeberUns />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registrieren" element={<Register />} />
              <Route path="/passwort-vergessen" element={<ForgotPassword />} />
              <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/mein-konto" element={<ProtectedRoute roles={["customer"]}><MeinKonto /></ProtectedRoute>} />
              <Route path="/scanner" element={<ProtectedRoute roles={["employee", "branch_manager", "admin"]}><EmployeeScanner /></ProtectedRoute>} />
            </Route>
            <Route path="/admin" element={<ProtectedRoute roles={["admin", "branch_manager", "event_manager", "marketing_manager"]}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
